import { Chip, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { NewTabLink } from "components/NewTabLink";
import { useShipmentQuoteCount, useSubscriptionStatus } from "hooks";
import {
  captureCarrierUpgradeCtaClicked,
  hasPaidCarrierSubscription,
} from "utils";

import {
  CARRIER_UPGRADE_RELATIVE_URL,
  CarrierUpgradeSource,
} from "../../../../constants";

interface Props {
  shipment: CarrierCondensedShipment;
}

export function QuoteCountChip(props: Props) {
  const { shipment } = props;
  const { quoteCount } = useShipmentQuoteCount(shipment?.info?.id);
  const posthog = usePostHog();

  const { subscription } = useSubscriptionStatus();

  if (subscription == null) {
    return null;
  }
  if (!hasPaidCarrierSubscription(subscription)) {
    return (
      <NewTabLink
        href={CARRIER_UPGRADE_RELATIVE_URL}
        onClick={() =>
          captureCarrierUpgradeCtaClicked(
            posthog,
            CarrierUpgradeSource.QUOTE_COUNT_CHIP,
          )
        }
      >
        <Typography>Upgrade to view quote count</Typography>
      </NewTabLink>
    );
  }
  if (quoteCount == null) {
    return null;
  }

  let text = "quotes";
  if (quoteCount === 1) {
    text = "quote";
  }

  return (
    <Chip
      label={<div className="quotes">{`${quoteCount} ${text}`}</div>}
      variant="outlined"
      color="info"
      size="small"
    />
  );
}
